<template>
	<div >
		<center>
     <div class="section product-description p-t-none">

      <div class="comment" style="width: 80%;margin-top: 10%;">



       <h2 class="title"><center><span><b>Careers</b></span></center></h2>


       <template>
        <v-card 
        margin= "5px"
        class="mx-auto"
        style="width: 100%;margin: 5px;"
        v-for="n in Careers" v-bind:key="n.id"
        >
        <v-list-item>
          <figure class="image is-64x64">
            <img class="is-rounded"  :src="require('@/assets/icon.png')" style="margin-top: 10px;height: 80%;width: 80%;">
          </figure>
          <v-list-item-content>

           <h2 class="text-left">{{n.JobName}}</h2> 
           <h4 class="text-left" style="color: black;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;overflow: hidden;">
            {{n.description}}
          </h4>
          <v-col
          cols="12"
          md="1"
          >
          <v-btn
          class="ma-2"
          outlined
          :to="'/CareerDetails/'+ n.ID"
          >Read More ..</v-btn>
        </v-col>
      </v-list-item-content>
    </v-list-item>


    <v-card-actions>
      <v-btn
      class="ma-2"
      color="green"
      outlined
      style="margin: 5px;">
      {{(n.afterInterview) ? 'TBD' : n.Salary }}
      <v-icon
      color="green"
      right>
      mdi-currency-usd
    </v-icon>
  </v-btn>
  <v-btn
  class="ma-2"
  color="green"
  outlined
  style="margin: 5px;">
  {{n.location}}
  <v-icon
  color="green"
  right>
  mdi-google-maps
</v-icon>
</v-btn>
<v-tooltip bottom>
  <template v-slot:activator="{ on, attrs }">
    <v-btn
    class="ma-2"
    color="green"
    outlined
    style="margin: 5px;">
    {{n.Experince}}
    <v-icon
    color="green"
    right>
    mdi-brain
  </v-icon>
</v-btn>
</template>
<span>Experince</span>
</v-tooltip>
<v-spacer></v-spacer>


<v-btn

outlined
color="indigo"
>
Apply This Job
<v-icon
right
dark
>
mdi-cloud-upload
</v-icon>
</v-btn>

</v-card-actions>
</v-card>
</template>

</div>
</div>
</center>
</div>
</template>

<script>

  export default {
   name: 'app',
   data () {
    return {
      dialog: false,
      partnerID : '',
    }
  },
  created(){
    this.$store.dispatch('bindCareers');
  },
  computed:{
    Careers(){
      return this.$store.state.Careers
    },
  },

}
</script>